import type { ExternalError } from '@setplex/pureya'
import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { createEvent } from 'effector'
import { or } from 'patronum'
import { model as config, remote } from '~/shared/config'

// Used by CSL, smart-restart, token expiry, etc. to reload URL to restart playback
export const reloadUrl = createEvent()

export const $isUrlRequestPending: Store<boolean> = or(
  api.player.loadVodUrl.pending,
  api.player.loadChannelUrlFx.pending,
  api.player.loadEpisodeUrlPlayer.pending,
  api.player.loadShowTrailerUrl.pending,
  api.player.loadVodTrailerUrl.pending,
  api.player.loadLiveEventUrlFx.pending,
  api.player.loadCatchupUrlFx.pending
)

export const $currentPlayerPageUrlErrorFormat: Store<ExternalError | null> =
  api.player.$currentPlayerPageUrlError.map((store) =>
    store
      ? {
          code: store.errorCode || store.code,
          message: store.message,
        }
      : null
  )
export const $isSmartlibEnabled = config.get(remote.tria_isSmartlibEnabled)
